import React from "react";

function Icon({ viewBox = "0 0 18 18", className = "" }) {
  return (
    <svg data-testid="contact-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox={viewBox} className={className}>
      <g>
        <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10">
          <path d="M6.378 10.127l5.997 4.498 2.25-11.25-11.25 4.5 1.502 1.126"></path>
          <path d="M8.723 11.886l-2.348 2.739.003-4.498L9.75 7.875"></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
